export default "__VITE_ASSET__YmocewGo__"